import GlobalFormCodeManager from '@/sections/forms/snippets/summary/snippets-summary-page.vue';
import CodeHistory from '@/sections/forms/snippets/history/snippets-history-page.vue';

export default [
	{
		name: 'code-manager',
		path: '/forms/code',
		component: GlobalFormCodeManager,
		props: route => ({
			search: route.query.search,
			sortBy: route.query.sortBy || 'Id',
			sortDirection: route.query.sortDirection || 'asc'
		}),
		meta: {
			permissions: ['forms.read']
		}
	},
	{
		name: 'code-history',
		path: '/forms/code/:changedEntityId?/history',
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search,
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			SourceApplication: route.query.SourceApplication || 'VueSupport',
			changedEntityId: route.params.changedEntityId,
			recordStart: parseInt(route.query.recordStart) || 1,
			maxCount: parseInt(route.query.maxCount) || 10
		}),
		component: CodeHistory,
		meta: {
			permissions: ['forms.read']
		}
	}
];
